import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Badge from '@mui/material/Badge';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import moment from 'moment';
import { Collapse } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { useState } from 'react';
import { dateFromMoment, nowdate } from '../../utils';
import { CalendarViewDay, DateRange, Email, EventBusy, HourglassEmpty, ListAlt, LocalShipping, Today, Warning } from '@mui/icons-material';
import { withStyles } from '@mui/styles';

let maxdate = dateFromMoment(moment().add(5, 'days'));


let DateItem = ({ label, Icon, onClick, style, isActive, date, classes }) => {
  return <ListItem disablePadding key={date} onClick={onClick} style={style} selected={isActive} >
    <ListItemButton>
      <ListItemIcon>
        <Icon style={style} />
      </ListItemIcon>
      <ListItemText primary={label} />
    </ListItemButton>
  </ListItem>
}



export default function PlannerMenu({ days, assets, setDate, setAsset, active, setArchive}) {
  const [isOpen, setIsOpen] = useState(false);

  let ma = dateFromMoment(moment());
  const isActive = ({ date, asset }) => {
    if (active && active.date && active.date.date === date) return true;
    if (active && active.asset && active.asset === asset) return true;
    return false;
  }
  let d1 = days.filter((x) => {return x.date <= maxdate});
  let d2 = days.filter((x) => {return x.date > maxdate});

  return <Box sx={{ overflow: 'auto' }}>
    <List>
      {d1.map(({ label, date }, index) => <DateItem key={date} label={label} Icon={date < ma ? Warning : DateRange} onClick={() => setDate({ label, date })} style={{ color: date < ma ? 'red' : 'inherit' }} isActive={isActive({ date })} />)}
    </List>
    <List>
      <ListItem button key='divider' onClick={()=>setIsOpen(!isOpen)}><ListItemText primary='További napok'/> {isOpen ? <ExpandLess/> : <ExpandMore/>} </ListItem>
      <Collapse key={maxdate} in={isOpen} timeout='auto' unmountOnExit>
        {d2.map(({ label, date }, index) => <DateItem key={date} label={label} Icon={date < ma ? Warning : DateRange} onClick={() => setDate({ label, date })} style={{ color: date < ma ? 'red' : 'inherit' }} isActive={isActive({ date })} />)}
      </Collapse>
    </List>
    <Divider />
    <List>
      {assets.map(({ id, color, cnt }) => {
        return (
          <ListItem key={id || 'Nincs'} disablePadding onClick={() => setAsset(id)} selected={isActive({ asset: id })}>
            <ListItemButton>
              <ListItemIcon>
                <Badge badgeContent={cnt} color="primary">
                  {color === '#999' ? <HourglassEmpty /> : color === '#df6' ? <LocalShipping /> : <Email />}
                </Badge>
              </ListItemIcon>
              <ListItemText primary={id} />
            </ListItemButton>
          </ListItem>
        )
      })}
      <Divider />
      <ListItem disablePadding onClick={setArchive} selected={active.archive}>
        <ListItemButton>
          <ListItemIcon>
            <ListAlt />
          </ListItemIcon>
          <ListItemText primary="Archívum" />
        </ListItemButton>
      </ListItem>
    </List>
  </Box>

}